import { Facebook, Instagram, Mail, MapPin } from "lucide-react";
import Wave from "react-wavify";
import logo from "../../assets/logo.png";

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div className={"bg-[#9a3415]"}>
            <div className={"bg-[#f8f6e3]"}>
                <Wave fill='#9a3415'
                      paused={true}
                      style={{display: 'flex'}}
                      options={{
                          height: 70,
                          amplitude: 50,
                          speed: 0.15,
                          points: 3
                      }}
                />
            </div>
            
            <div className="max-w-6xl mx-auto px-4 py-8 md:py-12">
                {/* Main Footer Content */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mb-8">
                    {/* Logo & Branding */}
                    <div className="flex flex-col items-center md:items-start">
                        <img src={logo} alt="Bar Elvire Logo" className="h-16 md:h-20 mb-2" />
                    </div>

                    {/* Quick Links */}
                    <div className="text-center md:text-left">
                        <h3 className="font-bold text-[#f8f6e3] mb-3 text-sm md:text-base">Navigatie</h3>
                        <ul className="space-y-1 text-xs md:text-sm">
                            <li><a href="#landing" className="text-[#f8f6e3] hover:text-white transition-colors">Home</a></li>
                            <li><a href="#menu" className="text-[#f8f6e3] hover:text-white transition-colors">Menu</a></li>
                            <li><a href="#contact" className="text-[#f8f6e3] hover:text-white transition-colors">Contact</a></li>
                            <li><a href="#reserveer" className="text-[#f8f6e3] hover:text-white transition-colors">Reserveren</a></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className="text-center md:text-left">
                        <h3 className="font-bold text-[#f8f6e3] mb-3 text-sm md:text-base">Contact</h3>
                        <div className="space-y-1 text-xs md:text-sm">
                            <a href="mailto:contact@bar-elvire.be" className="flex items-center justify-center md:justify-start gap-2 text-[#f8f6e3] hover:text-white transition-colors">
                                <Mail size={16} />
                                <span className="hidden md:inline">contact@bar-elvire.be</span>
                            </a>
                            <div className="flex items-start justify-center md:justify-start gap-2 text-[#f8f6e3]">
                                <MapPin size={16} className="flex-shrink-0 mt-0.5" />
                                <span className="hidden md:block">Gemeenteplein 22<br />2820 Rijmenam, België</span>
                            </div>
                        </div>
                    </div>

                    {/* Social Links */}
                    <div className="flex flex-col items-center md:items-start">
                        <h3 className="font-bold text-[#f8f6e3] mb-3 text-sm md:text-base">Volg ons</h3>
                        <div className="flex gap-2 md:gap-4">
                            <a href="https://www.instagram.com/bar_elvire" target="_blank" rel="noopener noreferrer" className="bg-[#f8f6e3] text-[#9a3415] p-2 md:p-3 rounded-full hover:bg-white transition-colors">
                                <Instagram size={16} />
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=61557993082732" target="_blank" rel="noopener noreferrer" className="bg-[#f8f6e3] text-[#9a3415] p-2 md:p-3 rounded-full hover:bg-white transition-colors">
                                <Facebook size={16} />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="border-t border-[#f8f6e3] border-opacity-30 pt-6 md:pt-8">
                    <div className="text-center">
                        <h2 className="font-black text-lg md:text-3xl text-[#f8f6e3] mb-2">Iedereen welkom en tot snel!</h2>
                        <p className="text-[#f8f6e3] text-xs md:text-sm opacity-80 mb-2">Ondernemingsnummer: 1008.719.529</p>
                        <p className="text-[#f8f6e3] text-xs opacity-70">© {currentYear} Bar Elvire</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;


